"use strict";

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FastLayer = void 0;

var Util_1 = require("./Util");

var Layer_1 = require("./Layer");

var Global_1 = require("./Global");

var FastLayer = /*#__PURE__*/function (_Layer_1$Layer) {
  _inherits(FastLayer, _Layer_1$Layer);

  var _super = _createSuper(FastLayer);

  function FastLayer(attrs) {
    var _this;

    _classCallCheck(this, FastLayer);

    _this = _super.call(this, attrs);

    _this.listening(false);

    Util_1.Util.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
    return _this;
  }

  return FastLayer;
}(Layer_1.Layer);

exports.FastLayer = FastLayer;
FastLayer.prototype.nodeType = 'FastLayer';
(0, Global_1._registerNode)(FastLayer);